import React from 'react';

import { Skeleton } from '@mui/material';

import { IBdsAvatar } from '../../../interfaces/bdsAvatar';
import './BdsAvatar.scss';

const BdsAvatar = ({ size, src, className, loading, showRing }: IBdsAvatar) => {
  const getInitials = (name?: string) => {
    if (!name) return '';
    const nameParts = name.split(' ');
    const initials = nameParts
      .map((part) => part[0])
      .join('')
      .substring(0, 2);
    return initials;
  };

  const renderChild = () => {
    if (src.photoUri) {
      return <img src={src.photoUri} alt="bds-avatar-img" />;
    }

    const text = getInitials(src.initials).toUpperCase();
    return <span>{text}</span>;
  };

  return (
    <div
      className={`bds-avatar-container flex items-center justify-center  ${size} ${className} ${
        showRing ? 'ring' : ''
      }`}
    >
      {loading ? (
        <Skeleton animation={false} className="skeleton" variant="circular" />
      ) : (
        <div className={'bds-avatar flex items-center justify-center'}>{renderChild()}</div>
      )}
    </div>
  );
};

export default BdsAvatar;
